import { useContext } from 'react';
import { BrandInfoContext } from '@core-ui/brand-info-provider';
import useEnabledFeature from '../../useEnabledFeature';
import useEnabledSegment from '../../useEnabledSegment';

const useDynamicStyleFacetName = () => {
  const { abbrBrand } = useContext(BrandInfoContext);
  const featureEnabled = useEnabledFeature('cat-style-v-category');
  const dynamicStyleFacetNameSegmentEnabled = useEnabledSegment(
    `${abbrBrand}113`
  );
  return featureEnabled && dynamicStyleFacetNameSegmentEnabled;
};

export default useDynamicStyleFacetName;
